import { FC, useRef } from 'react'
import { type Swiper as SwiperType } from 'swiper'
import { FreeMode, Mousewheel } from 'swiper/modules'
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react'

import { Auto, formatAutoNumber, useAutos } from '@/api/models/parking'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'
import { Badge } from '@/components/shared/badge'

type Props = {
  className?: string
  onSelect: (auto: Auto) => void
}

const PassQuickAutos: FC<Props> = ({ className, onSelect }) => {
  const { data: autos } = useAutos()
  const swiperRef = useRef<SwiperType | null>(null)
  const { breakpoint } = useCurrentBreakpoint()

  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  if (autos.length === 0) {
    return null
  }

  const renderAuto = (auto: Auto) => (
    <button
      key={auto.id}
      type="button"
      data-testid={`pass-quick-auto-${auto.id}-id`}
      onClick={() => onSelect(auto)}
    >
      <Badge className="gap-4 px-16 font-normal !text-16" variant="grey">
        {auto.emoji && <span>{auto.emoji}</span>}
        {formatAutoNumber(auto.number, auto.region)}
      </Badge>
    </button>
  )

  return (
    <div className={cn('flex flex-wrap gap-8', className)}>
      {isMobileScreen ? (
        <SwiperComponent
          modules={[FreeMode, Mousewheel]}
          slidesPerView="auto"
          spaceBetween={8}
          mousewheel
          watchOverflow
          threshold={10}
          className="!m-0 w-full"
          onInit={(swiper: SwiperType) => (swiperRef.current = swiper)}
        >
          {autos.map(auto => (
            <SwiperSlide key={auto.id} className="flex !w-auto justify-start">
              {renderAuto(auto)}
            </SwiperSlide>
          ))}
        </SwiperComponent>
      ) : (
        autos.map(element => renderAuto(element))
      )}
    </div>
  )
}

export { PassQuickAutos }
